import React from 'react';
import { Button } from 'antd';
import { loginIsLogin, loginModalOpen } from 'app/actions/Login/login.action';
import { setStateUserEnter } from 'app/actions/Users/user.enter.action';
import { FormattedMessage } from 'react-intl';
import {
  LETTER_SENT,
  START_LOGIN,
} from '../../../../constants/enter.user.constants';
import AbstractMachine from './abstractMachine';

export default class LetterSent extends AbstractMachine {
  constructor(form, goTo) {
    super(form, goTo);

    this._name = LETTER_SENT;
    this._nextState = START_LOGIN;
  }

  getName = () => {
    return this._name;
  };

  getTitle = () => {
    return '';
  };

  isShowFreePro = () => {
    return true;
  };

  submitHandler = () => {
    this._goTo(null, this.close);
  };

  close = (dispatch) => {
    dispatch(loginIsLogin(false));
    dispatch(loginModalOpen(false));
    dispatch(setStateUserEnter({ name: this._nextState }));
  };

  render({ userEmail, error }) {
    return (
      <div style={{ textAlign: 'center', fontSize: '12px', padding: '5px' }}>
        {error || (
          <div>
            <div className="empty-close-place" />
            <p>
              <FormattedMessage
                id="An e-mail was sent to"
                defaultMessage="An e-mail was sent to"
              />
              &nbsp;
              {userEmail}
              .
              <br />
              <FormattedMessage
                id="In the e-mail there is a description how to proceed and how to confirm your e-mail"
                defaultMessage="In the e-mail there is a description how to proceed and how to confirm your e-mail"
              />
              .
            </p>
            <p>
              <FormattedMessage
                id="If the e-mail doesn't appear within a few minutes, check you spam folder"
                defaultMessage="If the e-mail doesn't appear within a few minutes, check you spam folder"
              />
            </p>
          </div>
        )}

        <div className="step15" />
        <Button
          type="primary"
          className="ant-btn-primary width100"
          onClick={this.submitHandler}
        >
          <span>
            <FormattedMessage id="OK" defaultMessage="OK" />
          </span>
        </Button>
      </div>
    );
  }
}
